<template>
  <div class="search">
    <div class="search-layer">
      <Title />
      <SearchBar />
    </div>
  </div>
</template>

<script lang="ts">
import router from '@/router'
import { defineComponent, ref } from 'vue'
import Title from './title.vue'
import SearchBar from './searchBar.vue'

export default defineComponent({
  components: {
    Title,
    SearchBar,
  },

  setup() {
    const searchTxt = ref<string>('')
    const searchConcept = () => {
      router.push('./topicList')
    }
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        searchConcept()
      }
    }

    return {
      searchTxt,
      searchConcept,
      handleKeydown,
    }
  },
})
</script>

<style lang="less" scoped>
.search {
  display: flex;
  justify-content: center;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  margin-top: -10px;
  padding-left: 50px;
  background: url('../../../../common/image/assist/hd-bg.svg');
  .search-layer {
    width: 1250px;
    display: flex;
    justify-content: space-between;
    margin-left: 50px;
  }
}
@media screen and (max-width: 1250px) {
  .search-right {
    display: none;
  }
}
.mobile-viewport {
  .search-layer {
    margin-left: 0px;
    width: 100%;
  }
}
</style>

